import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';

export enum Environment {
  Production = 'production',
  Staging = 'staging',
  Local = 'local',
}

@Injectable({providedIn: 'root'})
export class EnvironmentService {

  private _localContentApi: boolean = false;
  private _localUserApi: boolean = false;
  private _bypassCache: boolean = false;

  private _environment: Environment;
  private _host: string = '';

  get env(): Environment {
    return this._environment;
  }

  get isSamsung(): boolean {
    return window.location.origin === "file://";
  }

  get userHost(): string {
    if (this._localUserApi) {
      return 'http://localhost:52635';
    }
    return 'https://user' + this._host + environment.domain;
  }

  get contentHost(): string {
    if (this._localContentApi) {
      return 'http://localhost:52902';
    }
    return 'https://content' + this._host + environment.domain;
  }

  get contentCdnHost(): string {
    if (this._localContentApi) {
      return 'http://localhost:52902';
    }
    return 'https://content' + (this._bypassCache ? '' : '-cache') + this._host + environment.domain;
  }

  get websocketCorridor(): string {
    return 'wss://ws' + this._host + environment.domain;
  }

  constructor() {
  }

  init(): Promise<void> {
    return new Promise(resolve => {
      this.setEnvironmentVariables();
      resolve();
    });
  }

  platform(): string {
    let platform = window.location.hostname.split('.')[0];
    if (platform === "smart-tv") {
      platform = "lg";
    }
    return platform;
  }

  private setEnvironmentVariables(): void {
    let hostname = window && window.location && window.location.hostname;

    if (hostname.includes('localhost')) {
      // hostname = Environment.Staging;
      // this._host = '-staging';
    } else {
      this._localContentApi = false; // don't let non-local connect to local api ever!
      this._localUserApi = false; // don't let non-local connect to local api ever!
      this._bypassCache = false;
    }

    if (hostname.includes('staging')) {
      this._environment = Environment.Staging;
      this._host = '-staging';
    } else {
      this._environment = Environment.Production;
      this._host = '';
    }
  }
}
